import { Product } from "../../services/types/gallus";

export const productsData: Product[] = [
  {
    Name: "Adv",
    Permissions: ["Advantage"],
    URLProduct: "/advantage",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Cambio",
    Permissions: ["CHM"],
    URLProduct: "/cambio",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "CK",
    Permissions: ["Celink"],
    URLProduct: "/celink",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Demo",
    Permissions: ["Demo"],
    URLProduct: "/demo",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "FM",
    Permissions: ["FCM"],
    URLProduct: "/fcm",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Flx",
    Permissions: ["Flexpoint"],
    URLProduct: "/flexpoint",
    IsFree: true,
    Enabled: true,
  },
/*   {
    Name: "GR",
    Permissions: ["GRate"],
    URLProduct: "/gr",
    IsFree: true,
    Enabled: true,
  }, */
  {
    Name: "KL",
    Permissions: [],
    URLProduct: "/kindlending",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "TLS",
    Permissions: ["LoanStore"],
    URLProduct: "/loanstore",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Nm",
    Permissions: ["Northern"],
    URLProduct: "/northernmortgage",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Panda",
    Permissions: ["PMG"],
    URLProduct: "/pmg",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "PRMG",
    Permissions: ["PRMG"],
    URLProduct: "/prmgprod",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "PRMG UAT",
    Permissions: ["PRMGUAT"],
    URLProduct: "/prmgUAT2",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "RD",
    Permissions: ["Radius"],
    URLProduct: "/radius",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "RLT",
    Permissions: ["Reliant"],
    URLProduct: "/reliant",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Rev",
    Permissions: ["Revolution"],
    URLProduct: "/revolution",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "DC",
    Permissions: ["DinerCap"],
    URLProduct: "/dinercap",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Cambio UAT",
    Permissions: ["CHMUAT"],
    URLProduct: "/cambiouat",
    IsFree: true,
    Enabled: true,
  },
];
